import { RouteObject } from 'react-router-dom';

import { AllEventsPage } from 'app/railways/domains/events/pages';
import { AllPassengersPage } from 'app/railways/domains/passengers/pages';
import { AddPersonPage } from 'app/railways/domains/passengers/pages/add/add-person.page';
import { DetailPersonPage } from 'app/railways/domains/passengers/pages/details/detail-person.page';
import { DetailsPersonFormPage } from 'app/railways/domains/passengers/pages/details/details-person-form.page';
import { CurrentUserPage } from 'app/railways/domains/profile/pages/profile.page';
import {
  DetailsTicketOrderPage,
  TicketOrdersPage,
  TicketsReportPage,
} from 'app/railways/domains/tickets/pages';
import {
  AddUserPage,
  AllUsersPage,
  DetailUserPage,
} from 'app/railways/domains/users/pages';
import { HomePage } from 'app/railways/pages/home';
import { BaseLayout } from 'app/railways/pages/layouts/base';

import { AddRolePage } from '../domains/access/pages/add-role.page';
import { AllRolesPage } from '../domains/access/pages/all-roles.page';
import { UpdateRolePage } from '../domains/access/pages/update-role.page';
import { AllReportsPage } from '../domains/reports/pages';
import { AddReportsPage } from '../domains/reports/pages/add-reports.page';
import { DetailsReportsPage } from '../domains/reports/pages/details-reports.page';
import { EditReportsPage } from '../domains/reports/pages/edit-reports.page';
import { AllRoutesPage } from '../domains/routes/pages/all-routes.page';
import { DetailsRoutePage } from '../domains/routes/pages/details-route.page';
import { AllTariffZonesPage } from '../domains/tariff-zones/pages/all-tariff-zones.page';
import { AddTariffProfilePage } from '../domains/tariffs/pages/add-tariff-profile.page';
import { AllTariffProfilesPage } from '../domains/tariffs/pages/all-tariff-profiles.page';
import { AllTariffsPage } from '../domains/tariffs/pages/all-tariffs.page';
import { DetailsTariffProfilePage } from '../domains/tariffs/pages/details-tariff-profile.page';
import { TariffPricesGridPage } from '../domains/tariffs/pages/tariff-prices.page';
import { AllTrainTypesPage } from '../domains/trips/pages/all-train-types.page';
import { AllTripsPage } from '../domains/trips/pages/all-trips.page';
import { DetailsTripPage } from '../domains/trips/pages/details-trip.page';
import { WagonSchemesPage } from '../domains/trips/pages/wagon-schemes.page';
import { appRoute } from './routes';

export const router: RouteObject[] = [
  {
    index: true,
    element: (
      <BaseLayout header="Главная страница">
        <HomePage />
      </BaseLayout>
    ),
  },
  // Пассажиры
  {
    path: appRoute.PERSONS.path,
    element: (
      <BaseLayout header="Все пассажиры">
        <AllPassengersPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.PERSONS.ADD.path,
    element: (
      <BaseLayout header="Добавление пассажира">
        <AddPersonPage />
      </BaseLayout>
    ),
  },

  {
    path: appRoute.PERSON.path,
    element: (
      <BaseLayout header="Информация о пассажире">
        <DetailPersonPage />
      </BaseLayout>
    ),
    children: [
      {
        path: appRoute.PERSON.DETAILS.path,
        element: <DetailsPersonFormPage />,
      },
    ],
  },

  // Билеты
  {
    path: appRoute.TICKETS.ORDERS.relativePath,
    element: (
      <BaseLayout header="Операции по заказам">
        <TicketOrdersPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.TICKETS.ORDER.relativePath,
    element: (
      <BaseLayout header="Данные заказа">
        <DetailsTicketOrderPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.TICKETS.REPORT.relativePath,
    element: (
      <BaseLayout header="Отчет по билетам">
        <TicketsReportPage />
      </BaseLayout>
    ),
  },

  // События
  {
    path: appRoute.EVENTS.path,
    element: (
      <BaseLayout header="Журнал событий">
        <AllEventsPage />
      </BaseLayout>
    ),
  },

  // Пользователи
  {
    path: appRoute.USERS.path,
    element: (
      <BaseLayout header="Все пользователи">
        <AllUsersPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.USERS.ADD.path,
    element: (
      <BaseLayout header="Добавление пользователя">
        <AddUserPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.USER.DETAILS.path,
    element: (
      <BaseLayout header="Информация о пользователе">
        <DetailUserPage />
      </BaseLayout>
    ),
  },
  // Роли
  {
    path: appRoute.ROLES.path,
    element: (
      <BaseLayout header="Все роли">
        <AllRolesPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.ROLES.DETAILS.path,
    element: (
      <BaseLayout header="Редактирование роли">
        <UpdateRolePage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.ROLES.ADD.path,
    element: (
      <BaseLayout header="Добавить роль">
        <AddRolePage />
      </BaseLayout>
    ),
  },

  // Профиль пользователя
  {
    path: appRoute.PROFILE.path,
    element: (
      <BaseLayout header="Профиль текущего пользователя">
        <CurrentUserPage />
      </BaseLayout>
    ),
  },

  // Маршруты
  {
    path: appRoute.TRIPS.path,
    element: (
      <BaseLayout header="Все рейсы">
        <AllTripsPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.TRIP.path,
    element: (
      <BaseLayout header="Данные рейса">
        <DetailsTripPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.TRAIN_TYPES.path,
    element: (
      <BaseLayout header="Типы составов">
        <AllTrainTypesPage />
      </BaseLayout>
    ),
  },

  // Схемы вагонов
  {
    path: appRoute.WAGON_SCHEMES.path,
    element: (
      <BaseLayout header="Все схемы вагонов">
        <WagonSchemesPage />
      </BaseLayout>
    ),
  },

  // Тарифы
  {
    path: appRoute.TARIFFS.path,
    element: (
      <BaseLayout header="Все виды тарифов">
        <AllTariffsPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.TARIFF_PRICES.path,
    element: (
      <BaseLayout header="Базовые цены тарифов">
        <TariffPricesGridPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.TARIFF_PROFILES.path,
    element: (
      <BaseLayout header="Профили тарифов">
        <AllTariffProfilesPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.TARIFF_PROFILES.ADD.path,
    element: (
      <BaseLayout header="Добавить профиль тарифа">
        <AddTariffProfilePage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.TARIFF_PROFILES.DETAILS.path,
    element: (
      <BaseLayout header="Редактировать профиль тарифа">
        <DetailsTariffProfilePage />
      </BaseLayout>
    ),
  },

  // Тарифные зоны
  {
    path: appRoute.TARIFF_ZONES.path,
    element: (
      <BaseLayout header="Все тарифные зоны">
        <AllTariffZonesPage />
      </BaseLayout>
    ),
  },

  //Маршруты
  {
    path: appRoute.ROUTES.path,
    element: (
      <BaseLayout header="Все маршруты">
        <AllRoutesPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.ROUTES.DETAILS.path,
    element: (
      <BaseLayout header="Данные маршрута">
        <DetailsRoutePage />
      </BaseLayout>
    ),
  },

  // Отчеты
  {
    path: appRoute.REPORTS.path,
    element: (
      <BaseLayout header="Все отчеты">
        <AllReportsPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.REPORTS.ADD.path,
    element: (
      <BaseLayout header="Добавить отчет">
        <AddReportsPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.REPORT.path,
    element: (
      <BaseLayout header="Информация об отчете">
        <DetailsReportsPage />
      </BaseLayout>
    ),
  },
  {
    path: appRoute.REPORT_EDIT.path,
    element: (
      <BaseLayout header="Редактирование отчета">
        <EditReportsPage />
      </BaseLayout>
    ),
  },
];
